import { useEffect, useRef, useState } from "react";
import {
  Container,
  ContainerCenter,
  ContainerRow,
  ContainerView,
  DesktopContainer,
  MobileContainer,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { TitleWithBack } from "../../components/Layout";

import {
  BalanceContainer,
  BalanceText,
  BalanceTitle,
  BalanceValue,
  BalanceValueBTC,
  BalanceValueEqual,
  BalanceValueIcon,
  EqualIcon,
} from "../wallet-list/styles";
import { ContainerTab, TabItem } from "../../components/Tab";
import { Form } from "antd";
import {
  FormButton,
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../components/Form";
import {
  errorView,
  formatCurrency,
  getConvertFee,
  getConvertNote,
  getWalletList,
  getWalletMLM,
  postCheckPhoneVerify,
  postConvert,
  roundNumber,
  transferWalletMLM,
} from "../../services/app";
import produce from "immer";
import ModalPhoneVerify from "../wallet-detail/modal";
import { DetailBalance } from "../wallet-detail/detail-balance";
import {
  InfoIcon,
  InfoTooltipIcon,
  TooltipView,
  WalletAlert,
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
  WalletDetailHeader,
  WalletDetailHeaderLeft,
  WalletDetailHeaderLeftContent,
  WalletDetailHeaderLeftIcon,
  WalletDetailHeaderRight,
  WalletDetailNotify,
  WalletDetailRow,
  WalletRow,
  WalletRowLeft,
  WalletRowRight,
  WalletRowRightFaq,
} from "../wallet-detail/styles";
import { useNavigate } from "react-router-dom";
const defaultValueMLM = {
  possibleBalanceSZT: 0,
  frozenBalanceSZT: 0,
};
export default function CommissionDetail(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    setAlert,
    setLoading,
  } = useApp();
  const navigate = useNavigate();
  const [dataMLM, setDataMLM] = useState(defaultValueMLM);
  const [wallets, setWallets] = useState([]);
  const [draftValue, setDraftValue] = useState({});
  const [fee, setFee] = useState(0);
  const [note, setNote] = useState({});
  const [form] = Form.useForm();
  const currentRef = useRef();
  const [available, setAvailable] = useState(false);
  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState(false);
  const [detailBalanceModal, setDetailBalanceModal] = useState();

  useEffect(() => {
    handleGetWalletMLM();
    loadData().then((currencyCode) => {
      form.setFieldsValue({ from: currencyCode || "" });
      setDraftValue({ from: currencyCode || "" });
    });
    let timer = setInterval(() => {
      if (!!currentRef?.current?.from && !!currentRef?.current?.to) {
        loadNote(currentRef.current.from, currentRef.current.to);
      }
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const onBack = () => {
    navigate("/commission");
  };

  const handleGetWalletMLM = async () => {
    try {
      const data = await getWalletMLM();
      setDataMLM(data?.data?.data || defaultValueMLM);
    } catch (error) {
      console.log(error);
    }
  };

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletList();
    if (result.status === 200) {
      const items = result?.data?.data?.wallets?.rows || [];
      setWallets(items);
    }
    setLoading(false);
    return "SZT";
  };

  const convertData = () => {
    return {
      wallet: {
        coin: "SZT",
        code: "SZT",
        cName: getNameByCode("SZT"),
        coinName: T(`${getNameByCode("SZT") || ""} (${"SZT"})`),
        amount: dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
        amountText: `${formatCurrency(
          dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT || 0
        )} ${"SZT"}`,
        local: convertToLocalCurrency(
          dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
          "SZT",
          getCurrency()
        ),
        localText: formatLocalCurrency(
          roundNumber(
            convertToLocalCurrency(
              dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
              "SZT",
              getCurrency()
            ) || 0,
            2
          )
        ),
        icon: `/assets/images/otc/crypto/szt.svg`,
      },
      rows: wallets.map((item, index) => {
        const data = {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          coinName: T(
            `${getNameByCode(item?.currency_code)} (${item.currency_code})`
          ),
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
        return data;
      }),
    };
  };

  const loadFee = async (amount, currencyCode) => {
    let result = await getConvertFee(amount, currencyCode);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };

  const loadNote = async (from, to) => {
    let result = await getConvertNote(from, to);
    if (result?.status === 200) {
      setNote(result?.data?.data || 0);
    }
  };

  const onTransactionHistory = () => {
    navigate(`/transaction-history/commission?code=SZT`);
  };

  const getNameByCode = (code) => {
    return currencies.find((item) => item.code === code)?.name || "";
  };

  const onConvert = async (values) => {
    const getValue = (code) => {
      const item = wallets.find((item) => item.currency_code === code);
      return item?.id || "";
    };
    setLoading(true);

    const resultVerify = await postCheckPhoneVerify(getValue(values.from));
    if (!!resultVerify?.data?.data?.isVerificationPhone) {
      setModal(true);
      setLoading(false);
      return;
    }

    const data = {
      destCurrencyCode: values.to,
      amount: values.amount,
    };

    const result = await transferWalletMLM(data);
    if (result.status === 200) {
      setAlert({
        type: "success",
        text: T("A conversion request has been created"),
      });
      form.resetFields();
      setAvailable(false);
      await loadData();
      onTransactionHistory();
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        setAlert({
          type: "error",
          text:
            result?.data?.error?.message ||
            T("Some error happened. Please try again later."),
        });
      }
    }
    setLoading(false);
  };

  const getFromCurrency = () => {
    return {
      coin: "SZT",
      amount: dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
      amountPossible: dataMLM.possibleBalanceSZT,
      btc: convertToBTC(
        dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
        "SZT",
        getCurrency()
      ),
      local: convertToLocalCurrency(
        dataMLM.frozenBalanceSZT + dataMLM.possibleBalanceSZT,
        "SZT",
        getCurrency()
      ),
    };
  };

  const value = convertData()?.wallet || {};
  const fromCurrency = getFromCurrency() || {};
  const onUpdateData = () => {
    const values = form.getFieldsValue();
    setDraftValue(values);
    if (values.from && values.amount) {
      loadFee(values.amount, values.from);
    }
    if (values.from && values.to) {
      currentRef.current = {
        from: values.from,
        to: values.to,
      };
      loadNote(values.from, values.to);
    } else {
      currentRef.current = {};
    }
    setAvailable(values.from && values.amount && values.to);
  };
  const renderGameCurrency = () => {
    return (
      <>
        <WalletDetailHeader>
          <DesktopContainer>
            <WalletDetailHeaderLeft>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  <BalanceTitle style={{ marginBottom: 15 }}>
                    <BalanceText>{value?.coinName}</BalanceText>
                  </BalanceTitle>
                  <BalanceValue>
                    <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                    <BalanceValueIcon>
                      <EqualIcon />
                    </BalanceValueIcon>
                    <BalanceValueEqual>{value?.localText}</BalanceValueEqual>
                    <TooltipView
                      color={"#EAF2FF"}
                      overlayClassName={"note-tooltip note-tooltip-2"}
                      title={
                        <div>
                          <span>
                            {T("Current period commission:")}
                            {dataMLM.frozenBalanceSZT} SZT
                          </span>
                          <br />
                          <span>
                            {T("Previous period commission:")}
                            {dataMLM.possibleBalanceSZT} SZT
                          </span>
                        </div>
                      }
                    >
                      <InfoIcon
                        style={{
                          opacity: 0.8,
                          marginLeft: 6,
                          marginBottom: 3,
                          cursor: "pointer",
                        }}
                      />
                    </TooltipView>
                  </BalanceValue>
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </DesktopContainer>
          <MobileContainer>
            <BalanceText>{value?.coinName}</BalanceText>
            <WalletDetailHeaderLeft style={{ marginTop: 16 }}>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  <BalanceTitle style={{ marginBottom: 5 }}>
                    <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                  </BalanceTitle>
                  <div
                    style={{
                      height: 1,
                      width: "100%",
                      border: "1px dashed #707070",
                      marginBottom: 10,
                    }}
                  />
                  <BalanceValue>
                    <BalanceValueIcon>
                      <EqualIcon />
                    </BalanceValueIcon>
                    <BalanceValueEqual>{value?.localText}</BalanceValueEqual>
                    <TooltipView
                      color={"#EAF2FF"}
                      overlayClassName={"note-tooltip note-tooltip-2"}
                      title={
                        <div>
                          <span>
                            {T("Current period commission:")}
                            {dataMLM.frozenBalanceSZT} SZT
                          </span>
                          <br />
                          <span>
                            {T("Previous period commission:")}
                            {dataMLM.possibleBalanceSZT} SZT
                          </span>
                        </div>
                      }
                    >
                      <InfoIcon
                        style={{
                          opacity: 0.8,
                          marginLeft: 6,
                          marginBottom: 3,
                          cursor: "pointer",
                        }}
                      />
                    </TooltipView>
                  </BalanceValue>
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </MobileContainer>

          <WalletDetailHeaderRight style={{ marginTop: 45 }}>
            <ContainerTab style={{ marginBottom: 0 }}>
              <TabItem
                className={"version-3 full-width"}
                style={{ marginRight: 0 }}
                onClick={() => {
                  onTransactionHistory();
                }}
              >
                {T("Transaction History")}
              </TabItem>
            </ContainerTab>
          </WalletDetailHeaderRight>
        </WalletDetailHeader>

        <WalletDetailRow className={"game-version"}>
          <WalletDetailNotify style={{ marginRight: 0 }}>
            <InfoIcon />
            <div
              dangerouslySetInnerHTML={{
                __html: T(
                  `convert.note.${value.coin?.toString().toLowerCase()}`
                ),
              }}
            />
          </WalletDetailNotify>

          <WalletRow>
            <WalletRowLeft>
              <Form
                layout={"vertical"}
                form={form}
                onFinish={(values) => {
                  onConvert(values);
                }}
                onValuesChange={() => {
                  onUpdateData();
                }}
              >
                <FormItemRow
                  name={"from"}
                  label={T("From Currency")}
                  initialValue={value.coin}
                  rules={[
                    {
                      required: true,
                      message: T("From Currency is required!"),
                    },
                  ]}
                >
                  <FormSelect>
                    {currencies
                      .filter((item) => item.code === "SZT")
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >
                            {T(item.name)} ({item.code})
                          </FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItemRow>
                <FormItemRow
                  {...errorView(errors, "destWalletId")}
                  name={"to"}
                  label={T("To Currency")}
                  rules={[
                    {
                      required: true,
                      message: T("To Currency is required!"),
                    },
                  ]}
                >
                  <FormSelect
                    onChange={() => {
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex(
                              (item) => item.key === "destWalletId"
                            ),
                            1
                          );
                        })
                      );
                    }}
                  >
                    {currencies
                      .filter((item) => item.is_to_allow_transfer === 1)
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >
                            {T(item.name)} ({item.code})
                          </FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItemRow>

                {draftValue?.from && draftValue?.to && note ? (
                  <ContainerRow style={{ marginBottom: 10, marginTop: 10 }}>
                    <Container style={{ flex: 1 }}>
                      <WalletDetailNotify
                        style={{ marginTop: 0, width: "100%" }}
                      >
                        <InfoIcon />
                        <div>
                          <ContainerRow style={{ alignItems: "center" }}>
                            <b>{note?.currentPair || ""}: </b>
                            <span style={{ marginLeft: 4 }}>
                              {note?.rate || ""}
                            </span>
                          </ContainerRow>
                        </div>
                      </WalletDetailNotify>
                    </Container>
                  </ContainerRow>
                ) : null}

                <FormItemRow
                  className="input-amount"
                  {...errorView(errors, "amount")}
                  name={"amount"}
                  label={T("Amount")}
                  rules={[
                    { required: true, message: T("Amount is required!") },
                  ]}
                >
                  <FormInputNumberRaw
                    onChange={() => {
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "amount"),
                            1
                          );
                        })
                      );
                    }}
                    min={0}
                    onAll={() => {
                      form.setFieldValue(
                        "amount",
                        parseFloat(fromCurrency?.amountPossible)
                      );
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "amount"),
                            1
                          );
                        })
                      );
                      onUpdateData();
                    }}
                    addonAfter={fromCurrency?.coin || ""}
                    placeholder={T(`Please enter the {coin} amount`).replace(
                      "{coin}",
                      fromCurrency?.coin || ""
                    )}
                  />
                </FormItemRow>
                {draftValue?.from &&
                draftValue?.to &&
                draftValue.amount &&
                note ? (
                  <ContainerRow style={{ marginBottom: 10, marginTop: 36 }}>
                    <Container style={{ flex: 1 }}>
                      <WalletDetailNotify
                        style={{ marginTop: 0, width: "100%" }}
                      >
                        <InfoIcon />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: T("converted-text")
                              .split("{currencyCode}")
                              .join(draftValue?.to)
                              .replace(
                                "{amount}",
                                formatCurrency(
                                  draftValue.amount * note?.rate,
                                  8
                                )
                              ),
                          }}
                        />
                      </WalletDetailNotify>
                    </Container>
                  </ContainerRow>
                ) : null}

                <ContainerRow style={{ marginTop: 40, marginBottom: 16 }}>
                  <WalletConvertInfo style={{ flex: 1 }}>
                    <WalletConvertInfoItem>
                      <WalletConvertInfoItemTitle>
                        {T("Possible to convert")}
                        <TooltipView
                          color={"#EAF2FF"}
                          overlayClassName={"note-tooltip"}
                          title={T(
                            "You can only convert commission that has been paid after closing period (end of month)"
                          )}
                        >
                          <InfoTooltipIcon style={{ marginLeft: 9 }} />
                        </TooltipView>
                      </WalletConvertInfoItemTitle>
                      <WalletConvertInfoItemValue>
                        {formatCurrency(fromCurrency?.amountPossible || 0)}{" "}
                        {fromCurrency?.coin}
                      </WalletConvertInfoItemValue>
                    </WalletConvertInfoItem>
                    {/* <WalletConvertInfoItem>
                      <WalletConvertInfoItemTitle>
                        {T("Fee")}
                      </WalletConvertInfoItemTitle>
                      <WalletConvertInfoItemValue className={"text-aia-red"}>
                        {parseFloat(fee || "0")} {fromCurrency?.coin}
                      </WalletConvertInfoItemValue>
                    </WalletConvertInfoItem> */}
                  </WalletConvertInfo>
                </ContainerRow>

                <ContainerRow style={{ marginBottom: 40 }}>
                  <Container style={{ flex: 1 }}>
                    <WalletAlert>
                      {T(
                        "After our team reviews and approves your request, the conversion will be executed."
                      )}
                    </WalletAlert>

                    <FormButton disabled={!available} htmlType={"submit"}>
                      {T("Request to Convert")}
                    </FormButton>
                  </Container>
                </ContainerRow>
              </Form>
            </WalletRowLeft>
          </WalletRow>
        </WalletDetailRow>
      </>
    );
  };
  return (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Commission wallet")} onClick={onBack} />
        {renderGameCurrency()}
      </ContainerView>

      {modal && (
        <ModalPhoneVerify
          onClose={(value) => {
            setModal(null);
            if (value) {
              setAlert({
                type: value,
                text:
                  value === "success"
                    ? T("Successfully verified your phone number")
                    : "",
              });
            }
            if (value === "success") {
            }
          }}
          value={modal}
        />
      )}
    </Container>
  );
}
